<template>
  <div class="ap-order">
    <div class="order-list" v-show="!$route.params.id">
      <div class="title">
        <span>我的订单</span>
        <select class="form-control form-control-sm float-right" style="width:auto;">
          <option disabled selected hidden>选择年份</option>
          <option>2020</option>
        </select>
      </div>
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link show active" data-toggle="tab" @click="switchover('ALL')">全部</a>
        </li>
        <li class="nav-item">
          <a class="nav-link show" data-toggle="tab" @click="switchover('UNCONFIRM')">待确认</a>
          <el-badge :value="count.countUnConfirmOrders.qty" :hidden="!count.countUnConfirmOrders.qty" class="item" />
        </li>
        <li class="nav-item">
          <a class="nav-link show" data-toggle="tab" @click="switchover('DOING')">执行中</a>
          <el-badge :value="count.countProcessingOrders.qty" :hidden="!count.countProcessingOrders.qty" class="item" />
        </li>
        <li class="nav-item">
          <a class="nav-link show" data-toggle="tab" @click="switchover('FINISHED')">已完结</a>
          <el-badge :value="count.countFinishedOrders.qty" :hidden="!count.countFinishedOrders.qty" class="item" />
        </li>
        <li class="nav-item">
          <a class="nav-link show" data-toggle="tab" @click="switchover('CANCEL')">已取消</a>
          <el-badge :value="count.countCanceledOrders.qty" :hidden="!count.countCanceledOrders.qty" class="item" />
        </li>
      </ul>
      <div style="padding:10px;">
        <strong>2020 订单</strong>
        <SearchField style="float:right;width:250px;" :small="true" :value.sync="searchText" @submit="search" placeholder="订单号/商品编号/货号/商品名称"/>
      </div>
      <div>
        <table class="table tb-header font12">
          <thead>
            <tr>
              <th class="col1">订单编号</th>
              <th>商品与数量</th>
              <th class="col3 text-right">订单金额</th>
              <th class="col4 text-center">订单状态</th>
              <th class="col5 text-center">操作</th>
            </tr>
          </thead>
        </table>
        <table class="table table-bordered font12" v-for="item in records" :key="item.number">
          <tbody>
            <tr class="order-header">
              <td class="col1 text-left">
                <span>{{item.orderTime | toShortDateTime}}</span>
                <span style="margin-left:12px;">
                  交易号
                  <span style="color:#f03;">{{item.poNumber}}</span>
                </span>
              </td>
              <td>{{item.recLmName}}</td>
              <td class="col3 text-right">
                <strong>￥ {{item.totalAmt | toMoney}}</strong>
              </td>
              <td class="col4 text-center">{{item.paymentMode}}</td>
              <td class="col5 text-center"></td>
            </tr>
            <tr class="order-child" v-for="it in item.orders" :key="it.id">
              <td class="col1 text-left">
                订单号：
                <router-link :to="'/buyer/order/'+it.id">{{it.number}}</router-link>
              </td>
              <td class="clearfix">
                <div class="float-left" style="width:110px">{{it.brandNameGroup}}</div>
                <div style="margin-left:110px">
                  <div class="clearfix">
                    <span class="float-left">{{it.genericComNameAndQty}}</span>
                  </div>
                </div>
              </td>
              <td class="col3 text-right">￥ {{it.finalTotalAmount | toMoney}}</td>
              <td class="col4 text-center">{{it | getStatus}}</td>
              <td class="col5 text-center">
                <router-link :to="'/buyer/order/'+it.id">查看详情</router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style="margin-top:30px">
        <Pagination ref="page" :onlyNumber="true" :total="total" @page-to="getData" />
      </div>
    </div>
    <div v-show="$route.params.id">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Pagination from "@components/Pagination.vue";
import SearchField from "@components/SearchField.vue";

export default {
  components: {
    Pagination,
    SearchField
  },
  data() {
    return {
      records: [],
      pageIndex: 1,
      total: 0,
      type: "",
      searchText: "",
      count: { countUnConfirmOrders: {}, countProcessingOrders: {} }
    };
  },
  created() {
    this.getData();
    this.getCount();
    document.title = "51 AUTOPARTS 我的订单";
  },
  methods: {
    detail(id) {
      this.$router.push(this.$route.path + "/" + id);
    },
    getCount() {
      this.$post("/opms/order/mall/statistics/").then(res => (this.count = res));
    },
    getData(args) {
      let data = {
        limit: args ? args.limit : this.$limit,
        offset: args ? args.offset : 0,
        criteria: {
          keyword: this.searchText || undefined
        }
      };
      if (this.type == "UNCONFIRM") {
        data.criteria.canceled = 0;
        data.criteria.confirmStatus = "UNCONFIRM";
      } else if (this.type == "DOING") {
        data.criteria.auditStatus = "APPROVED";
        data.criteria.confirmStatus = "APPROVED";
        data.criteria.isNotFinished = 1;
      } else if (this.type == "FINISHED") {
        data.criteria.auditStatus = "APPROVED";
        data.criteria.confirmStatus = "APPROVED";
        data.criteria.payStatus = "PAID";
      } else if (this.type == "CANCEL") {
        data.criteria.canceled = 1;
      }
      this.$post("/opms/order/query", data, {
        success(res) {
          let numberArr = [];
          let result = [];
          this.total = res.total;
          res.results.forEach(x => {
            let bName = x.brandNameGroup;
            if (bName) {
              x.brandNameGroup = Array.from(new Set(bName.split(","))).join();
            }
            if (numberArr.indexOf(x.poNumber) == -1) {
              numberArr.push(x.poNumber);
              let parent = {};
              parent.confirmStatus = x.confirmStatus;
              parent.shippingStatus = x.shippingStatus;
              parent.poNumber = x.poNumber;
              parent.orderTime = x.orderTime;
              parent.recLmName = x.recLmName;
              parent.isSplit = x.isSplit;
              parent.totalAmt = x.totalAmt;
              parent.paymentMode = x.paymentMode;
              parent.orders = [];
              parent.orders.push(x);
              result.push(parent);
            } else {
              result.forEach(y => {
                if (y.poNumber == x.poNumber) {
                  y.orders.push(x);
                }
              });
            }
          });
          this.records = result;
        }
      });
    },
    search() {
      this.$refs.page.pageIndex = 1;
      this.getData();
    },
    switchover(type) {
      this.type = type;
      this.searchText = "";
      this.$refs.page.pageIndex = 1;
      this.getData();
    }
  },
  filters: {
    getStatus(it) {
      if (it.canceled === true) {
        return "已取消";
      } else if (it.auditStatus === "UNAUDITED" || it.auditStatus === "DISAPPROVED") {
        return "审核中";
      } else if (it.auditStatus === "APPROVED" && it.confirmStatus === "UNCONFIRM") {
        return "待确认";
      } else if (it.confirmStatus === "APPROVED" && (it.payStatus === "UNPAID" || it.payStatus == "PAYING")) {
        return "执行中";
      } else if (it.confirmStatus === "APPROVED" && it.payStatus === "PAID") {
        return "已完结";
      }
    }
  }
};
</script>

<style lang="less">
.ap-order {
  padding: 20px;
  background: #fff;
  .nav-item {
    position: relative;
    .el-badge {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .title {
    margin-bottom: 10px;
    font-size: 24px;
  }
  .order-list {
    .table {
      tbody {
        color: #666;
      }
      .order-header {
        td {
          border-right-color: #fff;
          vertical-align: middle;
          &:last-child {
            border-right-color: #ecedf1;
          }
        }
        .col1 a {
          font-weight: bold;
          &:hover {
            font-weight: normal;
          }
        }
      }
    }
    .tb-header {
      margin-top: 10px;
      margin-bottom: 0;
      td {
        border-top: none;
      }
    }
    .order-child {
      background: #f2f2f2;
      &:hover {
        background: #ffc;
      }
    }
    .col1 {
      width: 306px;
      span,
      a {
        display: inline-block;
        vertical-align: top;
      }
      span + span {
        margin-left: 25px;
      }
      a {
        color: #f03;
        text-align: left;
        &:hover {
          color: #09c;
          text-decoration: underline;
        }
      }
    }
    .col3 {
      width: 150px;
    }
    .col4 {
      width: 114px;
    }
    .col5 {
      width: 126px;
      button {
        padding-top: 2px !important;
        padding-bottom: 2px !important;
      }
    }
  }
}
</style>